module.exports = __webpack_public_path__ + "static/media/app04_jpn.41712c14.png";